import React from "react";
import { Dialog, DialogProps } from "@material-ui/core";
import { DialogLayoutOptions, getDialogBackdropProps, getDialogLayout } from "../../consts/dialog";

export type StandardDialogProps = Omit<DialogProps, "fullScreen" | "fullWidth" | "maxWidth"> &
  DialogLayoutOptions;

/**
 * Material-UI Dialog with shared desktop/mobile sizing from `getDialogLayout`.
 * Use for any standalone dialog that is not opened via showDialog / showAuxiliaryDialog.
 */
export default function StandardDialog({
  children,
  maxWidth,
  fullScreen,
  widescreen,
  PaperProps,
  BackdropProps,
  ...rest
}: StandardDialogProps) {
  const layout = getDialogLayout({ maxWidth, fullScreen, widescreen });

  return (
    <Dialog
      {...rest}
      maxWidth={layout.maxWidth}
      fullWidth={layout.fullWidth}
      fullScreen={layout.fullScreen}
      BackdropProps={getDialogBackdropProps(BackdropProps)}
      PaperProps={{
        ...PaperProps,
        style: { ...layout.paperStyle, ...PaperProps?.style },
      }}
    >
      {children}
    </Dialog>
  );
}
